export default "__VITE_ASSET__DsOs5tZF__"